export const formatDate = (
  date: string | Date | undefined | null,
  withEst: boolean = true,
): string => {
  if (!date) return withEst ? "Est. --" : "--";

  const formatted = new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return withEst ? `Est. ${formatted}` : formatted;
};